// NEW: Component for rendering overlapping co-owner avatars
export const CoOwnerAvatars: React.FC<{ coOwners: any[], maxDisplay?: number, onClick?: () => void }> = ({ coOwners, maxDisplay = 3, onClick }) => {
  if (!coOwners || coOwners.length === 0) {
    return <span className="text-xs text-gray-400">None</span>;
  }

  const displayOwners = coOwners.slice(0, maxDisplay);
  const remainingCount = coOwners.length - maxDisplay;

  // NEW: Utility function to get initials from co-owner data
  const getCoOwnerInitials = (coOwner: any): string => {
    if (!coOwner) return "?";
    
    const name = coOwner.name?.trim();
    if (!name) {
      // Fallback to net_id if name is empty
      const netId = coOwner.net_id?.trim();
      if (netId && netId.length >= 2) {
        return netId.substring(0, 2).toUpperCase();
      }
      return "?";
    }
    
    // Handle comma-separated names like "Aarthi, for testing"
    const cleanName = name.split(',')[0].trim();
    const nameParts = cleanName.split(/\s+/);
    
    if (nameParts.length >= 2) {
      // First letter of first name + First letter of last name
      return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
    } else if (nameParts.length === 1 && nameParts[0].length >= 2) {
      // For single names, take first two letters
      return nameParts[0].substring(0, 2).toUpperCase();
    } else if (nameParts.length === 1 && nameParts[0].length === 1) {
      // For single letter names, use that letter twice or fallback
      return (nameParts[0].charAt(0) + nameParts[0].charAt(0)).toUpperCase();
    }
    
    return "?";
  };

  return (
    <div 
      className={`flex items-center ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
      onClick={onClick ? (e) => {
        e.stopPropagation();
        onClick();
      } : undefined}
    >
      {displayOwners.map((owner, index) => {
        const initials = getCoOwnerInitials(owner);
        const fullName = owner.name || owner.net_id || "Unknown";
        
        return (
          <div
            key={index}
            className={`w-6 h-6 rounded-full bg-black text-white text-xs flex items-center justify-center font-medium border-2 border-white ${
              index > 0 ? '-ml-2' : ''
            }`}
            title={`${owner.name || owner.net_id} (${owner.net_id})\n${owner.role || ''}`}
            style={{ fontSize: '10px', zIndex: maxDisplay - index }}
          >
            {initials}
          </div>
        );
      })}
      {remainingCount > 0 && (
        <div
          className="w-6 h-6 rounded-full bg-gray-400 text-white text-xs flex items-center justify-center font-medium border-2 border-white -ml-2"
          title={`+${remainingCount} more`}
          style={{ fontSize: '9px' }}
        >
          +{remainingCount}
        </div>
      )}
    </div>
  );
};